// Mock data for HH Law Office website

export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      blog: "Insights",
      contact: "Contact"
    },
    hero: {
      headline: "Expert Legal Solutions in Turkey",
      subheadline: "Specialized in Intellectual Property, Corporate Law & Real Estate",
      cta: "Book Free Consultation",
      learnMore: "Our Services"
    },
    services: {
      title: "Practice Areas",
      subtitle: "Comprehensive legal expertise tailored to your needs",
      items: [
        {
          id: 1,
          title: "Intellectual Property Law",
          description: "Protecting your creative assets and innovations. We handle patent applications, copyright protection, and IP litigation with specialized expertise.",
          features: ["Patent Applications", "Copyright Protection", "IP Litigation", "Licensing Agreements", "Trade Secrets"]
        },
        {
          id: 2,
          title: "Trademark Law",
          description: "Comprehensive trademark services from registration to enforcement. We protect your brand identity across national and international markets.",
          features: ["Trademark Registration", "Trademark Search", "Opposition Proceedings", "Trademark Litigation", "Brand Protection"]
        },
        {
          id: 3,
          title: "Corporate Law",
          description: "Strategic legal counsel for businesses operating in Turkey. From company formation to complex commercial transactions, we provide comprehensive corporate legal services.",
          features: ["Company Formation", "Mergers & Acquisitions", "Commercial Contracts", "Corporate Governance", "Regulatory Compliance"]
        },
        {
          id: 4,
          title: "Real Estate Law",
          description: "Expert guidance through Turkey's real estate market. We assist with property acquisitions, due diligence, and all aspects of real estate transactions for local and international clients.",
          features: ["Property Acquisition", "Due Diligence", "Title Verification", "Lease Agreements", "Foreign Investment"]
        },
        {
          id: 5,
          title: "Start-up Law",
          description: "Legal support for startups from formation to growth stage. We help entrepreneurs navigate legal complexities and secure investments.",
          features: ["Company Formation", "Investment Agreements", "SAFE & Convertible Notes", "Equity Structuring", "Regulatory Compliance"]
        },
        {
          id: 6,
          title: "AI Law",
          description: "Legal guidance for AI development, deployment and compliance. We help businesses navigate the evolving regulatory landscape of artificial intelligence.",
          features: ["AI Governance", "AI Contracts", "Data Protection", "Algorithmic Accountability", "AI Ethics Compliance"]
        }
      ]
    },
    about: {
      title: "About HH Law Office",
      subtitle: "Your Trusted Legal Partner in Turkey",
      description: "HH Law Office is a forward-thinking legal practice headquartered in Istanbul, Turkey. Our firm combines deep expertise in Turkish law with an international perspective, particularly in intellectual property matters.",
      story: "Founded with a vision to provide exceptional legal services, our team brings together experience from leading Turkish law firms and specialized international education, including advanced studies in intellectual property law through the prestigious WIPO-University of Turin program.",
      mission: "Our mission is to become a leading international intellectual property firm while maintaining excellence in corporate and real estate law services in Turkey.",
      stats: [
        { value: "IP", label: "Specialization" },
        { value: "6", label: "Practice Areas" },
        { value: "WIPO", label: "Accredited" },
        { value: "24/7", label: "Client Support" }
      ]
    },
    blog: {
      title: "Legal Insights",
      subtitle: "Stay informed with our latest articles and updates",
      posts: [
        {
          id: 1,
          title: "Understanding Trademark Registration in Turkey",
          excerpt: "A comprehensive guide to protecting your brand in the Turkish market through trademark registration.",
          date: "August 2025",
          category: "Intellectual Property"
        },
        {
          id: 2,
          title: "Foreign Investment in Turkish Real Estate",
          excerpt: "Key considerations for international investors looking to acquire property in Turkey.",
          date: "July 2025",
          category: "Real Estate"
        },
        {
          id: 3,
          title: "Corporate Compliance Updates 2025",
          excerpt: "Recent regulatory changes affecting businesses operating in Turkey.",
          date: "June 2025",
          category: "Corporate Law"
        }
      ]
    },
    contact: {
      title: "Contact Us",
      subtitle: "Schedule your free consultation today",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        service: "Service of Interest",
        message: "Your Message",
        submit: "Request Consultation",
        success: "Thank you! We will contact you shortly."
      },
      info: {
        address: "42 Maslak Ahi Evran Caddesi No:6 Ofis 3 Kat 5 Sarıyer/İstanbul",
        email: "info@hh-lawoffice.com",
        hours: "Monday - Friday: 9:00 - 18:00"
      }
    },
    footer: {
      description: "HH Law Office provides expert legal services in intellectual property, corporate law, and real estate across Turkey.",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  },
  tr: {
    nav: {
      home: "Ana Sayfa",
      services: "Faaliyet Alanları",
      about: "Hakkımızda",
      blog: "Yayınlar",
      contact: "İletişim"
    },
    hero: {
      headline: "Türkiye'de Hukuki Danışmanlık",
      subheadline: "Fikri Mülkiyet, Ticaret Hukuku ve Gayrimenkul Hukuku Alanlarında Uzman Kadro",
      cta: "Randevu Alın",
      learnMore: "Faaliyet Alanlarımız"
    },
    services: {
      title: "Faaliyet Alanları",
      subtitle: "Hukuki ihtiyaçlarınıza yönelik kapsamlı danışmanlık hizmetleri",
      items: [
        {
          id: 1,
          title: "Fikri Mülkiyet Hukuku",
          description: "Fikri ve sınai mülkiyet haklarınızın korunması için uzmanlık hizmeti. Patent, telif hakları ve fikri mülkiyet uyuşmazlıkları konularında hizmet vermekteyiz.",
          features: ["Patent ve Faydalı Model", "Telif Hakları", "Fikri Mülkiyet Davaları", "Lisans ve Devir Sözleşmeleri", "Ticari Sırlar"]
        },
        {
          id: 2,
          title: "Marka Hukuku",
          description: "Marka tescilinden uyuşmazlık çözümüne kadar kapsamlı marka hukuku hizmetleri. Ulusal ve uluslararası pazarlarda marka kimliğinizi koruyoruz.",
          features: ["Marka Tescil", "Marka Araştırması", "İtiraz Süreçleri", "Marka Davaları", "Marka Koruma"]
        },
        {
          id: 3,
          title: "Ticaret ve Şirketler Hukuku",
          description: "Türkiye'de faaliyet gösteren yerli ve yabancı şirketlere yönelik stratejik hukuki danışmanlık. Şirket kuruluşundan yapılandırma projelerine kadar geniş kapsamlı ticari hukuk hizmetleri sunmaktayız.",
          features: ["Şirket Kuruluşu ve Ana Sözleşme", "Birleşme ve Devralma (M&A)", "Ticari Sözleşmeler", "Kurumsal Yönetim", "Uyum ve Regülasyon"]
        },
        {
          id: 4,
          title: "Gayrimenkul Hukuku",
          description: "Türkiye gayrimenkul sektöründe yerli ve yabancı müvekkillere yönelik kapsamlı hukuki danışmanlık. Taşınmaz alım-satımı, hukuki inceleme (due diligence) ve gayrimenkul uyuşmazlıkları konularında destek sağlamaktayız.",
          features: ["Taşınmaz Alım-Satım", "Hukuki İnceleme (Due Diligence)", "Tapu ve Kadastro İşlemleri", "Kira Sözleşmeleri", "Yabancıların Mülk Edinimi"]
        },
        {
          id: 5,
          title: "Start-Up Hukuku",
          description: "Kuruluştan büyüme aşamasına kadar start-up'lar için hukuki destek. Girişimcilerin hukuki karmaşıklıkları aşmasına ve yatırım almasına yardımcı oluyoruz.",
          features: ["Şirket Kuruluşu", "Yatırım Sözleşmeleri", "SAFE ve Dönüştürülebilir Tahvil", "Hisse Yapılandırması", "Mevzuat Uyumu"]
        },
        {
          id: 6,
          title: "Yapay Zeka Hukuku",
          description: "Yapay zeka geliştirme, uygulama ve uyum konularında hukuki rehberlik. İşletmelerin yapay zekanın gelişen düzenleyici ortamında yol almasına yardımcı oluyoruz.",
          features: ["Yapay Zeka Yönetişimi", "Yapay Zeka Sözleşmeleri", "Veri Koruma", "Algoritmik Hesap Verebilirlik", "Yapay Zeka Etik Uyumu"]
        }
      ]
    },
    about: {
      title: "HH Hukuk Bürosu",
      subtitle: "Türkiye'de Güvenilir Hukuk Danışmanınız",
      description: "HH Hukuk Bürosu, İstanbul merkezli olarak faaliyet gösteren, özellikle fikri mülkiyet alanında uluslararası deneyime sahip bir hukuk bürosudur.",
      story: "Kurucu ortağımız, Türkiye'nin önde gelen hukuk bürolarında edindiği ticaret hukuku deneyiminin ardından, WIPO-Torino Üniversitesi Fikri Mülkiyet Hukuku Yüksek Lisans programını tamamlamıştır. Bu birikim, büromuzun uluslararası standartlarda hizmet sunmasını sağlamaktadır.",
      mission: "Hedefimiz, fikri mülkiyet alanında uluslararası düzeyde tanınan bir hukuk bürosu olmak ve ticaret ile gayrimenkul hukuku alanlarındaki hizmet kalitemizi sürdürmektir.",
      stats: [
        { value: "FM", label: "Odak Alan" },
        { value: "6", label: "Faaliyet Alanı" },
        { value: "WIPO", label: "Akreditasyon" },
        { value: "7/24", label: "Erişilebilirlik" }
      ]
    },
    blog: {
      title: "Güncel Yazılar",
      subtitle: "Hukuki gelişmeler ve sektörel değerlendirmeler",
      posts: [
        {
          id: 1,
          title: "Türkiye'de Marka Tescil Süreci",
          excerpt: "TÜRKPATENT nezdinde marka tescil başvurusu ve dikkat edilmesi gereken hususlar.",
          date: "Ağustos 2025",
          category: "Fikri Mülkiyet"
        },
        {
          id: 2,
          title: "Yabancıların Türkiye'de Taşınmaz Edinimi",
          excerpt: "Yabancı gerçek ve tüzel kişilerin Türkiye'de gayrimenkul edinme şartları ve prosedürü.",
          date: "Temmuz 2025",
          category: "Gayrimenkul"
        },
        {
          id: 3,
          title: "2025 Ticaret Kanunu Değişiklikleri",
          excerpt: "Şirketleri etkileyen güncel mevzuat değişiklikleri ve uyum gereksinimleri.",
          date: "Haziran 2025",
          category: "Şirketler Hukuku"
        }
      ]
    },
    contact: {
      title: "Bize Ulaşın",
      subtitle: "İlk görüşme için randevu talep edin",
      form: {
        name: "Adınız Soyadınız",
        email: "E-posta Adresiniz",
        phone: "Telefon Numaranız",
        service: "İlgilendiğiniz Alan",
        message: "Mesajınız",
        submit: "Gönder",
        success: "Talebiniz alınmıştır. En kısa sürede sizinle iletişime geçeceğiz."
      },
      info: {
        address: "42 Maslak Ahi Evran Caddesi No:6 Ofis 3 Kat 5 Sarıyer/İstanbul",
        email: "info@hh-lawoffice.com",
        hours: "Pazartesi - Cuma: 09:00 - 18:00"
      }
    },
    footer: {
      description: "HH Hukuk Bürosu, fikri mülkiyet, ticaret hukuku ve gayrimenkul hukuku alanlarında Türkiye genelinde hukuki danışmanlık hizmeti sunmaktadır.",
      rights: "Tüm hakları saklıdır.",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Koşulları"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Nosotros",
      blog: "Artículos",
      contact: "Contacto"
    },
    hero: {
      headline: "Soluciones Legales Expertas en Turquía",
      subheadline: "Especializados en Propiedad Intelectual, Derecho Mercantil e Inmobiliario",
      cta: "Consulta Gratuita",
      learnMore: "Nuestros Servicios"
    },
    services: {
      title: "Áreas de Práctica",
      subtitle: "Experiencia legal integral adaptada a sus necesidades",
      items: [
        {
          id: 1,
          title: "Derecho de Propiedad Intelectual",
          description: "Protegemos sus activos creativos e innovaciones. Manejamos solicitudes de patentes, protección de derechos de autor y litigios de propiedad intelectual.",
          features: ["Solicitudes de Patentes", "Protección de Derechos de Autor", "Litigios de PI", "Acuerdos de Licencia", "Secretos Comerciales"]
        },
        {
          id: 2,
          title: "Derecho de Marcas",
          description: "Servicios integrales de marcas desde el registro hasta la aplicación. Protegemos su identidad de marca en mercados nacionales e internacionales.",
          features: ["Registro de Marcas", "Búsqueda de Marcas", "Procedimientos de Oposición", "Litigios de Marcas", "Protección de Marca"]
        },
        {
          id: 3,
          title: "Derecho Mercantil y Societario",
          description: "Asesoría legal estratégica para empresas que operan en Turquía. Desde la constitución de sociedades hasta transacciones comerciales complejas, proporcionamos servicios legales corporativos integrales.",
          features: ["Constitución de Sociedades", "Fusiones y Adquisiciones", "Contratos Mercantiles", "Gobierno Corporativo", "Cumplimiento Normativo"]
        },
        {
          id: 4,
          title: "Derecho Inmobiliario",
          description: "Orientación experta en el mercado inmobiliario de Turquía. Asistimos con adquisiciones de propiedades, diligencia debida y todos los aspectos de transacciones inmobiliarias para clientes locales e internacionales.",
          features: ["Adquisición de Propiedades", "Diligencia Debida", "Verificación de Títulos", "Contratos de Arrendamiento", "Inversión Extranjera"]
        },
        {
          id: 5,
          title: "Derecho de Start-ups",
          description: "Apoyo legal para startups desde la constitución hasta la etapa de crecimiento. Ayudamos a los emprendedores a navegar las complejidades legales y asegurar inversiones.",
          features: ["Constitución de Empresas", "Acuerdos de Inversión", "SAFE y Notas Convertibles", "Estructuración de Capital", "Cumplimiento Normativo"]
        },
        {
          id: 6,
          title: "Derecho de IA",
          description: "Orientación legal para el desarrollo, implementación y cumplimiento de IA. Ayudamos a las empresas a navegar el panorama regulatorio en evolución de la inteligencia artificial.",
          features: ["Gobernanza de IA", "Contratos de IA", "Protección de Datos", "Responsabilidad Algorítmica", "Cumplimiento Ético de IA"]
        }
      ]
    },
    about: {
      title: "Sobre HH Law Office",
      subtitle: "Su Socio Legal de Confianza en Turquía",
      description: "HH Law Office es un despacho de abogados con visión de futuro con sede en Estambul, Turquía. Nuestro bufete combina profunda experiencia en derecho turco con una perspectiva internacional, particularmente en asuntos de propiedad intelectual.",
      story: "Fundado con la visión de proporcionar servicios legales excepcionales, nuestro equipo reúne experiencia de los principales despachos de abogados turcos y educación internacional especializada, incluyendo estudios avanzados en derecho de propiedad intelectual a través del prestigioso programa OMPI-Universidad de Turín.",
      mission: "Nuestra misión es convertirnos en un bufete internacional líder en propiedad intelectual mientras mantenemos la excelencia en servicios de derecho mercantil e inmobiliario en Turquía.",
      stats: [
        { value: "PI", label: "Especialización" },
        { value: "6", label: "Áreas de Práctica" },
        { value: "OMPI", label: "Acreditado" },
        { value: "24/7", label: "Atención al Cliente" }
      ]
    },
    blog: {
      title: "Perspectivas Legales",
      subtitle: "Manténgase informado con nuestros últimos artículos y actualizaciones",
      posts: [
        {
          id: 1,
          title: "Entendiendo el Registro de Marcas en Turquía",
          excerpt: "Una guía completa para proteger su marca en el mercado turco mediante el registro de marcas.",
          date: "Agosto 2025",
          category: "Propiedad Intelectual"
        },
        {
          id: 2,
          title: "Inversión Extranjera en Inmuebles Turcos",
          excerpt: "Consideraciones clave para inversores internacionales que buscan adquirir propiedades en Turquía.",
          date: "Julio 2025",
          category: "Inmobiliario"
        },
        {
          id: 3,
          title: "Actualizaciones de Cumplimiento Corporativo 2025",
          excerpt: "Cambios regulatorios recientes que afectan a las empresas que operan en Turquía.",
          date: "Junio 2025",
          category: "Derecho Mercantil"
        }
      ]
    },
    contact: {
      title: "Contáctenos",
      subtitle: "Programe su consulta gratuita hoy",
      form: {
        name: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Número de Teléfono",
        service: "Servicio de Interés",
        message: "Su Mensaje",
        submit: "Solicitar Consulta",
        success: "¡Gracias! Nos pondremos en contacto pronto."
      },
      info: {
        address: "42 Maslak Ahi Evran Caddesi No:6 Ofis 3 Kat 5 Sarıyer/İstanbul",
        email: "info@hh-lawoffice.com",
        hours: "Lunes - Viernes: 9:00 - 18:00"
      }
    },
    footer: {
      description: "HH Law Office proporciona servicios legales expertos en propiedad intelectual, derecho mercantil e inmobiliario en toda Turquía.",
      rights: "Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À propos",
      blog: "Articles",
      contact: "Contact"
    },
    hero: {
      headline: "Solutions Juridiques Expertes en Turquie",
      subheadline: "Spécialisés en Propriété Intellectuelle, Droit des Affaires et Immobilier",
      cta: "Consultation Gratuite",
      learnMore: "Nos Services"
    },
    services: {
      title: "Domaines de Pratique",
      subtitle: "Expertise juridique complète adaptée à vos besoins",
      items: [
        {
          id: 1,
          title: "Droit de la Propriété Intellectuelle",
          description: "Protection de vos actifs créatifs et innovations. Nous gérons les demandes de brevets, la protection des droits d'auteur et les litiges en propriété intellectuelle.",
          features: ["Demandes de Brevets", "Protection des Droits d'Auteur", "Contentieux de la PI", "Accords de Licence", "Secrets Commerciaux"]
        },
        {
          id: 2,
          title: "Droit des Marques",
          description: "Services complets en matière de marques, de l'enregistrement à l'application. Nous protégeons votre identité de marque sur les marchés nationaux et internationaux.",
          features: ["Enregistrement de Marques", "Recherche de Marques", "Procédures d'Opposition", "Contentieux des Marques", "Protection de Marque"]
        },
        {
          id: 3,
          title: "Droit des Affaires et des Sociétés",
          description: "Conseil juridique stratégique pour les entreprises opérant en Turquie. De la constitution de sociétés aux transactions commerciales complexes, nous fournissons des services juridiques d'entreprise complets.",
          features: ["Constitution de Sociétés", "Fusions et Acquisitions", "Contrats Commerciaux", "Gouvernance d'Entreprise", "Conformité Réglementaire"]
        },
        {
          id: 4,
          title: "Droit Immobilier",
          description: "Orientation experte sur le marché immobilier turc. Nous assistons dans les acquisitions immobilières, la due diligence et tous les aspects des transactions immobilières pour les clients locaux et internationaux.",
          features: ["Acquisition Immobilière", "Due Diligence", "Vérification des Titres", "Baux Commerciaux et Résidentiels", "Investissement Étranger"]
        },
        {
          id: 5,
          title: "Droit des Start-ups",
          description: "Support juridique pour les startups de la constitution à la phase de croissance. Nous aidons les entrepreneurs à naviguer les complexités juridiques et à sécuriser les investissements.",
          features: ["Constitution de Sociétés", "Accords d'Investissement", "SAFE et Obligations Convertibles", "Structuration du Capital", "Conformité Réglementaire"]
        },
        {
          id: 6,
          title: "Droit de l'IA",
          description: "Orientation juridique pour le développement, le déploiement et la conformité de l'IA. Nous aidons les entreprises à naviguer dans le paysage réglementaire en évolution de l'intelligence artificielle.",
          features: ["Gouvernance de l'IA", "Contrats IA", "Protection des Données", "Responsabilité Algorithmique", "Conformité Éthique IA"]
        }
      ]
    },
    about: {
      title: "À propos de HH Law Office",
      subtitle: "Votre Partenaire Juridique de Confiance en Turquie",
      description: "HH Law Office est un cabinet d'avocats tourné vers l'avenir, basé à Istanbul, en Turquie. Notre cabinet combine une expertise approfondie du droit turc avec une perspective internationale, particulièrement en matière de propriété intellectuelle.",
      story: "Fondé avec la vision de fournir des services juridiques exceptionnels, notre équipe réunit l'expérience des principaux cabinets d'avocats turcs et une formation internationale spécialisée, incluant des études avancées en droit de la propriété intellectuelle à travers le prestigieux programme OMPI-Université de Turin.",
      mission: "Notre mission est de devenir un cabinet international leader en propriété intellectuelle tout en maintenant l'excellence dans les services de droit des affaires et immobilier en Turquie.",
      stats: [
        { value: "PI", label: "Spécialisation" },
        { value: "6", label: "Domaines" },
        { value: "OMPI", label: "Accrédité" },
        { value: "24/7", label: "Service Client" }
      ]
    },
    blog: {
      title: "Perspectives Juridiques",
      subtitle: "Restez informé avec nos derniers articles et mises à jour",
      posts: [
        {
          id: 1,
          title: "Comprendre l'Enregistrement de Marques en Turquie",
          excerpt: "Un guide complet pour protéger votre marque sur le marché turc par l'enregistrement de marques.",
          date: "Août 2025",
          category: "Propriété Intellectuelle"
        },
        {
          id: 2,
          title: "Investissement Étranger dans l'Immobilier Turc",
          excerpt: "Considérations clés pour les investisseurs internationaux souhaitant acquérir des propriétés en Turquie.",
          date: "Juillet 2025",
          category: "Immobilier"
        },
        {
          id: 3,
          title: "Mises à Jour de Conformité des Entreprises 2025",
          excerpt: "Changements réglementaires récents affectant les entreprises opérant en Turquie.",
          date: "Juin 2025",
          category: "Droit des Affaires"
        }
      ]
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Planifiez votre consultation gratuite aujourd'hui",
      form: {
        name: "Nom Complet",
        email: "Adresse Email",
        phone: "Numéro de Téléphone",
        service: "Service d'Intérêt",
        message: "Votre Message",
        submit: "Demander une Consultation",
        success: "Merci ! Nous vous contacterons bientôt."
      },
      info: {
        address: "42 Maslak Ahi Evran Caddesi No:6 Ofis 3 Kat 5 Sarıyer/İstanbul",
        email: "info@hh-lawoffice.com",
        hours: "Lundi - Vendredi: 9:00 - 18:00"
      }
    },
    footer: {
      description: "HH Law Office fournit des services juridiques experts en propriété intellectuelle, droit des affaires et immobilier dans toute la Turquie.",
      rights: "Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation"
    }
  }
};

export const serviceIcons = {
  ip: "Shield",
  corporate: "Building2",
  realEstate: "Home"
};
